import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Title, Text, Button } from '@mantine/core'

const PageNotFound: React.FC = () => {
  return (
    <Container style={{ textAlign: 'center', padding: '50px' }}>
      <Title order={1}>Page Not Found</Title>
      <Text size="lg" mt="md">
        Oops! The page you're looking for doesn't exist.
      </Text>
      <Button component={Link} to="/" mt="lg">
        Go Back Home
      </Button>
    </Container>
  )
}

export default PageNotFound
